export { Forgot as default } from '@/modules/user/Login';
